export default __webpack_public_path__ + "1f49bfe0fd2a97d68000bf9a20a7f890.png";